// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'
import { getWebConfig } from "@/utils/config";
import { ensureGateCbOnAddressBar } from '@/utils/gateCb'
import { isActivityEnabled } from '@/utils/activity'
import { Toast } from 'vant'
import store from '@/store'

/** 后续新活动路由在 meta 上挂 activityCode；未开启则拦截 */
const ensureActivityAccess = (to) => {
    const activityCode = to.meta?.activityCode
    if (!activityCode) return true
    if (isActivityEnabled(store, activityCode, false)) return true
    Toast('活动暂未开放')
    return false
}

const routes = [
    {
        path: '/',
        name: 'Home',
        alias: '/index.html',
        component: () => import('@/views/Home/index.vue'),
        meta: {
            title: '首页',
            requiresAuth: true
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword/index.vue'),
        meta: {
            title: '忘记密码'
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile/index.vue'),
        meta: {
            title: '个人中心',
            requiresAuth: true
        }
    },
    {
        path: '/app-download',
        name: 'AppDownload',
        component: () => import('@/views/AppDownloadPage/index.vue'),
        meta: {
            title: 'APP下载',
        }
    },
    {
        path: '/project',
        name: 'Project',
        component: () => import('@/views/Project/index.vue'),
        meta: {
            title: '抖音合伙人',
            requiresAuth: true
        }
    },
    {
        path: '/projects',
        name: 'TeamProject',
        component: () => import('@/views/TeamProject/index.vue'),
        meta: {
            title: '团队项目',
            requiresAuth: true
        }
    },
    {
        path: '/industry',
        name: 'IndustryProject',
        component: () => import('@/views/IndustryProject/index.vue'),
        meta: {
            title: '产业转型产品',
            requiresAuth: true
        }
    },
    {
        path: '/consume',
        name: 'ConsumeProject',
        component: () => import('@/views/ConsumeProject/index.vue'),
        meta: {
            title: '消费项目',
            requiresAuth: true
        }
    },
    {
        path: '/consume-orders',
        name: 'ConsumeProjectOrders',
        component: () => import('@/views/ConsumeProject/Orders.vue'),
        meta: {
            title: '消费项目订单',
            requiresAuth: true
        }
    },
    {
        path: '/mall',
        redirect: '/projects'
    },
    {
        path: '/orders',
        name: 'OrderList',
        component: () => import('@/views/Mall/OrderList/index.vue'),
        meta: {
            requiresAuth: true,
            title: '我的订单'
        }
    },
    {
        path: '/address',
        name: 'Address',
        component: () => import('@/views/AddressManagement/index.vue'),
        meta: {
            requiresAuth: true,
            title: '地址管理'
        }
    },
    {
        path: '/address/add',
        name: 'AddressAdd',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/address/edit/:id',
        name: 'AddressEdit',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/bank-cards',
        name: 'BankCards',
        component: () => import('@/views/BankCard/index.vue'),
        meta: {
            requiresAuth: true,
            title: '银行卡管理'
        }
    },
    {
        path: '/verification',
        name: 'Verification',
        component: () => import('@/views/Verification/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/security',
        name: 'Security',
        component: () => import('@/views/Security/index.vue'),
        meta: {
            title: '安全中心',
            requiresAuth: true
        }
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('@/views/Help/index.vue'),
        meta: {
            title: '帮助中心',
            requiresAuth: true
        }
    },
    {
        path: '/news',
        name: 'NewsList',
        component: () => import('@/views/News/index.vue'),
        meta: {
            title: '新闻资讯',
            requiresAuth: true
        }
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: () => import('@/views/News/detail.vue'),
        meta: {
            title: '新闻详情',
            requiresAuth: true
        }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About/index.vue'),
        meta: {
            title: '关于我们',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw',
        name: 'Withdraw',
        component: () => import('@/views/Withdraw/index.vue'),
        meta: {
            title: '提现',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-bind',
        name: 'WithdrawBind',
        component: () => import('@/views/WithdrawBind/index.vue'),
        meta: {
            title: '提现信息绑定',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-asset',
        name: 'WithdrawAsset',
        component: () => import('@/views/WithdrawAsset/index.vue'),
        meta: {
            title: '提现到资产余额',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-history',
        name: 'WithdrawHistory',
        component: () => import('@/views/WithdrawHistory/index.vue'),
        meta: {
            title: '提现明细',
            requiresAuth: true
        }
    },
    {
        path: '/asset-history',
        name: 'AssetHistory',
        component: () => import('@/views/AssetHistory/index.vue'),
        meta: {
            title: '资产明细',
            requiresAuth: true
        }
    },
    {
        path: '/bind-bank-card',
        name: 'BindBankCard',
        component: () => import('@/views/BindBankCard/index.vue'),
        meta: {
            title: '绑定银行卡',
            requiresAuth: true
        }
    },
    {
        path: '/real-name',
        name: 'RealName',
        component: () => import('@/views/RealName/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/team',
        name: 'Team',
        component: () => import('@/views/Team/index.vue'),
        meta: {
            title: '我的团队',
            requiresAuth: true
        }
    },
    {
        path: '/invite',
        name: 'Invite',
        component: () => import('@/views/Invite/index.vue'),
        meta: {
            title: '邀请好友',
            requiresAuth: true
        }
    },
    {
        path: '/consume-coupon-invite',
        name: 'ConsumeCouponInvite',
        component: () => import('@/views/ConsumeCouponInvite/index.vue'),
        meta: {
            title: '消费促进活动',
            requiresAuth: true,
            activityCode: 'consume_coupon_invite',
        }
    },
    {
        path: '/securities-transfer',
        name: 'SecuritiesTransfer',
        component: () => import('@/views/SecuritiesTransfer/index.vue'),
        meta: {
            title: '银证转账功能',
            requiresAuth: true,
        }
    },
    {
        path: '/tax-repayment',
        name: 'TaxRepayment',
        component: () => import('@/views/TaxRepayment/index.vue'),
        meta: {
            title: '补缴税费',
            requiresAuth: true,
        }
    },
    {
        path: '/final-settlement',
        name: 'FinalSettlement',
        component: () => import('@/views/FinalSettlement/index.vue'),
        meta: {
            title: '银行资金最终清算',
            requiresAuth: true,
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login/index.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/Register/index.vue'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/download/guide',
        name: 'downloadGuide',
        component: () => import('@/views/DownloadGuidePage/index.vue'),
        meta: {
            title: '下载指引'
        }
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('@/views/Agreement/index.vue'),
        meta: {
            title: '用户服务协议',
            agreementType: 'terms'
        }
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('@/views/Agreement/index.vue'),
        meta: {
            title: '隐私政策',
            agreementType: 'privacy'
        }
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/views/error/403.vue'),
        meta: {
            title: '无权访问'
        }
    },
    {
        path: '/monthly-sign-in',
        name: 'MonthlySignIn',
        component: () => import('@/views/MonthlySignIn/index.vue'),
        meta: {
            title: '月度签到',
            requiresAuth: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/views/error/404.vue'),
        meta: {
            title: '页面未找到'
        }
    },
    {
        path: '/gift',
        name: 'Gift',
        component: () => import('@/views/Gift/index.vue'),
        meta: {
            title: '抽奖',
        }
    },
    {
        path: '/gift-history',
        name: 'GiftHistory',
        component: () => import('@/views/GiftHistory/index.vue'),
        meta: {
            title: '中奖记录',
        }
    },
    {
        path: '/equity',
        name: 'Equity',
        component: () => import('@/views/Equity/index.vue'),
        meta: {
            title: '认领股权',
            requiresAuth: true
        }
    },
    {
        path: '/stock',
        redirect: '/equity'
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        // 始终滚动到顶部
        return { top: 0 }
    }
})

// 白名单：不需要登录就可以访问的路由
const whiteList = ['/login', '/register', '/forgot-password', '/403', '/404', '/app-download', '/download/guide', '/terms', '/privacy']

router.beforeEach(async (to, from, next) => {
    const webConfig = getWebConfig();
    const web_name = webConfig?.web_name || "抖音火山版";
    document.title = to.meta.title ? `${to.meta.title} - ${web_name}` : `${web_name}`

    const token = getToken()

    // 判断是否有token
    if (token) {
        if (to.path === '/login' || to.path === '/register') {
            // 已登录状态下访问登录页，重定向到首页
            next('/')
        } else {
            // 判断是否已经获取了用户信息
            if (store.state.user.name) {
                if (!ensureActivityAccess(to)) {
                    next(from.path && from.path !== to.path ? false : '/')
                    return
                }
                next()
            } else {
                try {
                    // 获取用户信息
                    await store.dispatch('user/getUserInfo')
                    if (!ensureActivityAccess(to)) {
                        next('/')
                        return
                    }
                    next()
                } catch (error) {
                    // 获取用户信息失败，可能是token失效
                    await store.dispatch('user/logout')
                    Toast.fail('登录状态已过期，请重新登录')
                    next(`/login?redirect=${to.path}`)
                }
            }
        }
    } else {
        // 没有token
        if (whiteList.includes(to.path) || to.path.startsWith('/download/') || !to.meta.requiresAuth) {
            if (!ensureActivityAccess(to)) {
                next('/')
                return
            }
            // 白名单中的页面或不需要认证的页面，直接访问
            next()
        } else {
            // 其他需要登录的页面，重定向到登录页
            next(`/login?redirect=${to.path}`)
        }
    }
})

router.afterEach((to) => {
    ensureGateCbOnAddressBar(to.path)
})

export default router